import { render } from "./GerenciamentoUsuariosLogados.vue?vue&type=template&id=b0907126&scoped=true"
import script from "./GerenciamentoUsuariosLogados.vue?vue&type=script&lang=js"
export * from "./GerenciamentoUsuariosLogados.vue?vue&type=script&lang=js"

import "./GerenciamentoUsuariosLogados.vue?vue&type=style&index=0&id=b0907126&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0907126"]])

export default __exports__